import React from 'react';
import { Clock, CheckCircle, ShoppingBag, RotateCcw } from 'lucide-react';
import { Order } from '../types';
import { Button } from './ui/Button';
interface OrderCardProps {
  order: Order;
  onReorder?: () => void;
}
export function OrderCard({
  order,
  onReorder
}: OrderCardProps) {
  const statusColors = {
    'order-sent': 'text-blue-600 bg-blue-50',
    preparing: 'text-orange-600 bg-orange-50',
    ready: 'text-green-600 bg-green-50',
    completed: 'text-gray-600 bg-gray-50'
  };
  const statusLabels = {
    'order-sent': 'Order Sent',
    preparing: 'Preparing',
    ready: 'Ready for Pickup',
    completed: 'Completed'
  };
  return <div className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100" data-id="element-61">
      <div className="flex justify-between items-start mb-3" data-id="element-62">
        <div className="flex items-center gap-3" data-id="element-63">
          <div className="w-10 h-10 rounded-lg bg-gray-100 overflow-hidden" data-id="element-64">
            <img src={order.storeImage} alt={order.storeName} className="w-full h-full object-cover" data-id="element-65" />
          </div>
          <div data-id="element-66">
            <h3 className="font-bold text-gray-900" data-id="element-67">{order.storeName}</h3>
            <p className="text-xs text-gray-500" data-id="element-68">{order.date}</p>
          </div>
        </div>
        <span className={`text-xs font-bold px-2.5 py-1 rounded-full ${statusColors[order.status]}`} data-id="element-69">
          {statusLabels[order.status]}
        </span>
      </div>

      <div className="border-t border-gray-100 my-3 pt-3" data-id="element-70">
        <p className="text-sm text-gray-600 mb-1" data-id="element-71">
          {order.items.map(i => `${i.quantity}x ${i.name}`).join(', ')}
        </p>
        <p className="text-sm font-bold text-gray-900" data-id="element-72">
          Total: ${order.total.toFixed(2)}
        </p>
      </div>

      {onReorder && <Button variant="secondary" size="sm" fullWidth onClick={onReorder} className="mt-2" data-id="element-73">
          <RotateCcw size={14} className="mr-2" data-id="element-74" /> Reorder
        </Button>}
    </div>;
}